<form [formGroup]="form" class="style-form row">
  <div style="display: flex" class="col-12">
    <p class="inputRadio">¿Existe personal interno involucrado?</p>
    <mat-radio-group
      style="margin-left: 60px"
      formControlName="involucrado"
      aria-label="Select an option"
    >
      <mat-radio-button value="Si">Si</mat-radio-button>
      <mat-radio-button style="margin-left: 10px" value="No"
        >No</mat-radio-button
      >
    </mat-radio-group>
  </div>
</form>
